<template>
  <div class="details">
    <div class="details__container details__info-container">
      <Instructor
        class="details__instructor"
        :instructor="course.instructors[0]"
      />
      <div class="details__wrapper">
        <Stats
          class="details__stats"
          :course="course"
          :isAuthenticated="isAuthenticated"
        />
        <button
          class="details__btn-resume btn btn--secondary btn--default-icon-color"
          @click="$emit('resume')"
        >
          <PlayIcon /> Resume
        </button>
      </div>
    </div>
    <div
      v-if="showProgress"
      class="details__container details__progress-bar-container"
    >
      <div class="details__progress-bar">
        <div
          v-tooltip="{
            content: `<div class='progress-bar__tooltip-content'>Course Progress:<br>${progress}% Complete</div>`,
            placement: 'top-center',
          }"
          class="details__progress-bar-completed"
          :style="`width: ${progress}%`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Instructor from '@/components/course/details/Instructor.vue'
import Stats from '@/components/course/details/Stats.vue'
import { PlayIcon } from 'vue-feather-icons'
import { mapState } from 'vuex'

export default {
  name: 'Details',
  components: {
    Instructor,
    Stats,
    PlayIcon,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    progress: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
    showProgress() {
      const { has_trackable_content, status: courseStatus } = this.course
      const isNotComingSoon = courseStatus !== 'coming soon'

      return this.isAuthenticated && isNotComingSoon && has_trackable_content
    },
  },
}
</script>

<style lang="scss" scoped>
.details {
  border-radius: 10px;
  background: var(--dark-page-fill);
  &__container {
    display: flex;
    background: var(--glass-mid-gray);

    &:first-child {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    &:last-child {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    @include tablet {
      flex-wrap: wrap;
    }
  }
  &__info-container {
    flex-direction: column;
    padding: 20px;

    @include desktop {
      gap: 30px;
      min-height: 120px;
      flex-direction: row;
      align-items: center;
    }
  }
  &__instructor {
    flex: 1;
  }
  &__wrapper {
    display: flex;
    flex-direction: column;

    @include desktop {
      flex-direction: row;
      justify-content: flex-end;
      margin-left: auto;
      gap: 30px;
    }
  }
  &__btn-resume {
    margin-top: 15px;
    @include desktop {
      margin: 0;
    }
  }
  &__progress-bar {
    width: 100%;
    height: 7px;
    border-radius: 10px;
    background-color: var(--white-20);
    &-container {
      padding: 10px 20px;
    }

    &-completed {
      height: inherit;
      border-radius: inherit;
      background-color: var(--positive-light);
      cursor: pointer;
    }
  }
}
</style>
